var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPresentation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.78125 0.75H15.2188C15.5742 0.75 15.875 1.05078 15.875 1.40625C15.875 1.78906 15.5742 2.0625 15.2188 2.0625H0.78125C0.398438 2.0625 0.125 1.78906 0.125 1.40625C0.125 1.05078 0.398438 0.75 0.78125 0.75ZM1 2.9375H2.3125V8.84375C2.3125 8.98047 2.39453 9.0625 2.53125 9.0625H8H13.4688C13.5781 9.0625 13.6875 8.98047 13.6875 8.84375V2.9375H15V8.84375C15 9.69141 14.2891 10.375 13.4688 10.375H8.62891V11.6602L10.625 13.6562C10.8984 13.9023 10.8984 14.3125 10.625 14.5586C10.3789 14.832 9.96875 14.832 9.69531 14.5586L7.97266 12.8359L6.25 14.5586C6.00391 14.832 5.59375 14.832 5.34766 14.5586C5.07422 14.3125 5.07422 13.9023 5.34766 13.6562L7.34375 11.6602V10.375H2.53125C1.68359 10.375 1 9.69141 1 8.84375V2.9375Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPresentation);
export default __webpack_public_path__ + "static/media/presentation.7fea1e0fd795c977a445ad0b8d86f863.svg";
export { ForwardRef as ReactComponent };